import { SvgProps } from "components/icons/types";

export const WavyArrowRight = (props: SvgProps) => (
  <svg
    width="25"
    height="11"
    viewBox="0 0 25 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.416748 2.98991C1.35537 2.48989 7.43249 -1.16269 8.61962 1.21158C9.75139 3.4751 4.32249 7.55979 7.17942 9.70248C9.62746 11.5385 14.5808 9.36885 16.9728 8.38752C18.5706 7.73202 19.892 6.66326 21.3685 5.83273C21.4761 5.77223 22.3687 5.24413 22.0573 5.24413"
      stroke="currentColor"
      strokeWidth="0.833333"
      strokeLinecap="round"
    />
    <path
      d="M20.4167 4.1139C21.2986 4.04672 24.7025 3.02252 24.0235 4.74008C23.6608 5.65748 23.3472 6.27487 23.3472 7.26981"
      stroke="currentColor"
      strokeWidth="0.704445"
      strokeLinecap="round"
    />
  </svg>
);
